// The sign-in page's passkey block belongs to the passkeys pack. The React
// form, a separate bundle, knows something the block can't: whether the
// account typed in has a passkey, which may be on another device (a phone)
// that this browser won't suggest by itself.
export const OFFER_EVENT = 'passkey:offer'

// true or false once the form has looked the account up, null until then.
export const offerPasskeySignIn = accountHasOne =>
  document.querySelector('[data-passkey="sign-in"]')
    ?.dispatchEvent(new CustomEvent(OFFER_EVENT, { detail: accountHasOne }))
